export default __webpack_public_path__ + "static/media/IMG_0259 copie.721973ac.jpg";